export default __webpack_public_path__ + "static/media/Spinner.af0a4943.svg";